import script from "./TabFieldCamera.vue?vue&type=script&setup=true&lang=js"
export * from "./TabFieldCamera.vue?vue&type=script&setup=true&lang=js"

import "./TabFieldCamera.vue?vue&type=style&index=0&id=119997a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119997a8"]])

export default __exports__